module.exports = __webpack_public_path__ + "static/media/Mast_CBD_retina.6019e5fc.jpg";